const paths = {
  HOME:                                    '/',
  MENU_LIST:                               ':businessID/menus',
  ORDER_RESULT:                            ':businessID/orders/result',

  ICON_RENDER:                             '/svg/render',
}

export default paths;